function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("metadata", null, "Created by potrace 1.10, written by Peter Selinger 2001-2011");

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.000000,284.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, React.createElement("path", {
  d: "M1434 2546 c-37 -31 -37 -87 0 -124 23 -23 35 -26 143 -33 146 -9\n260 -37 380 -94 220 -104 349 -230 471 -461 75 -141 112 -161 186 -103 25 20\n28 27 24 64 -3 23 -24 79 -47 125 -196 391 -611 650 -1043 650 -77 0 -90 -3\n-114 -24z"
}), React.createElement("path", {
  d: "M925 2410 c-178 -93 -350 -272 -456 -475 -180 -341 -185 -736 -14\n-1080 63 -126 115 -200 218 -304 112 -114 263 -221 313 -221 29 0 64 28 79 63\n21 50 4 78 -88 140 -114 78 -186 144 -258 240 -310 409 -269 968 98 1334 35\n35 101 88 148 119 46 30 91 65 100 77 22 31 19 72 -7 101 -36 40 -66 41 -133\n6z"
}), React.createElement("path", {
  d: "M1125 2116 c-40 -17 -84 -63 -101 -103 -11 -26 -14 -147 -14 -620 0\n-549 2 -591 19 -628 45 -101 155 -138 256 -88 98 50 975 560 999 582 38 34 56\n80 56 138 0 56 -23 99 -73 137 -40 30 -932 549 -992 577 -47 22 -108 24 -150\n5z"
}), React.createElement("path", {
  d: "M2569 1406 c-20 -20 -27 -42 -38 -122 -19 -147 -46 -239 -100 -349\n-128 -258 -371 -456 -651 -530 -108 -28 -140 -53 -140 -110 0 -40 47 -85 89\n-85 43 0 247 68 332 110 189 93 333 221 459 405 98 144 148 272 180 461 26\n153 26 176 -6 213 -34 40 -89 43 -125 7z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.0,
    width: "300.000000pt",
    height: "284.000000pt",
    viewBox: "0 0 300.000000 284.000000",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/play-demo.aa990476.svg";
export { SvgComponent as ReactComponent };